export default "/assets/images/critter-cuddler1.png?c1cc007a8f2e252284b50b5ef6fe453b";